import React from "react";
import commonRoutes from "./common.routes";
import ReVAMPDashboard from "../components/Dashboard/ReVAMP_Dashboard/ReVAMPDashboard";

import LocomotiveOEM from "../components/LocomotiveOEMRecord";
import BlueCardReportContainer from "../components/BlueCardReport";
import LITEDailyInspectionReport from "../components/ReVAMPDailyInpectionReports";
import MobileAppView from "../components/MobileAppView";
import ReVAMPOutOfUseContainer from "../components/ReVAMPOutOfUse/ReVAMPOutOfUse";
//import ReviewReportPage from "../components/ReviewsCertifications/ReviewsCertificationsReports/ReviewReportPage";
import ReviewsCertificationsWrapper from "../components/ReviewsCertifications";
import ConsistComponent from "../components/Consist";

const isApp = () => localStorage.getItem("source") && localStorage.getItem("source") === "MobileApp";

const getReVAMPRoutes = () => {
  let liteR = [
    {
      path: "/oemlocomotive",
      component: isApp()
        ? () => {
            return (
              <MobileAppView>
                <LocomotiveOEM />
              </MobileAppView>
            );
          }
        : LocomotiveOEM,
    },
    {
      path: "/bluecard",
      component: isApp()
        ? () => {
            return (
              <MobileAppView>
                <BlueCardReportContainer />
              </MobileAppView>
            );
          }
        : BlueCardReportContainer,
    },

    {
      path: "/dailyreport",
      component: isApp()
        ? () => {
            return (
              <MobileAppView>
                <LITEDailyInspectionReport />
              </MobileAppView>
            );
          }
        : LITEDailyInspectionReport,
    },
    {
      path: "/OutOfUse/:id",
      component: ReVAMPOutOfUseContainer,
    },
    { path: "/consist", component: ConsistComponent },
    { path: "/reviewsCertifications", component: ReviewsCertificationsWrapper },

    //{ path: "/reviewReport", component: ReviewReportPage },

    ...commonRoutes.map((route) => {
      if (route.path === "/dashboard" || route.path === "/") {
        return {
          ...route,
          component: ReVAMPDashboard,
        };
      }
      return route;
    }),
  ];

  return [...liteR];
};

export default getReVAMPRoutes();



// WEBPACK FOOTER //
// ./src/routes/ReVAMP.routes.js